import { computed } from "vue";
import { useQuery } from "@tanstack/vue-query";
import profileService from "@/services/profile";

export const useApplicationMasterRecord = ({ applicationId }) => {
  const { data: applicationData } = useQuery({
    queryKey: computed(() => ["getApplication", applicationId]),
    queryFn: async () =>
      await profileService.getApplicationById({
        applicationId: applicationId,
      }),
    enabled: computed(() => !!applicationId),
  });

  const application = computed(() => applicationData.value?.data ?? {});
  return {
    application,
  };
};
